import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "The fitness coach at Fitclub provided expert guidance and support, leading you to achieve your ideal body through the right plan and program.",
    name : 'RAHUL ZANDENNAVAR',
    status : 'COACH'
  },
  {
    image: image2,
    review:'The fitness coach at Fitclub was exceptional, providing knowledgeable guidance and motivating support that helped me achieve my fitness goals.Their expertise and dedication made all the difference in my journey. ',
    name: 'SATISH KOKANE',
    status: 'CLIENT'
  },
  {
    image : image3,
    review:'One-to-one training offers a personalized fitness experience tailored to your specific goals and needs, allowing for individualized attention and maximum results.With dedicated focus and customized guidance, you can optimize your workouts and make significant progress towards your fitness aspirations.',
    name: 'SHAAN AND SWAGAT',
    status: "CLIENTS"
  }
];
